// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"463":"4c6d89dc","646":"b172b83b"}[chunkId] + ".chunk.js";
};